module.exports = __webpack_public_path__ + "media/images/icon__compete-ca6d628c2b5f32b7acbf5f1b3cf0a1a9.png";